import http from "../../backend/http.js";

async function getDocuments(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `documents?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}
async function getDocument(id) {
  try {
    const response = await http.get(`documents/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      blocks: response.data.blocks,
      date: response.data.date,
      author: {
        id: response.data.author.id,
        title: response.data.author.title,
      },
      tags: response.data.tags,
    };
  } catch (err) {
    throw err;
  }
}

async function createDocument(block) {
  try {
    const response = await http.post("documents", block);
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateDocumentsTitle(id, title) {
  try {
    const response = await http.patch(`documents/${id}`, { value: title });
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateDocumentsTags(id, tags) {
  try {
    const response = await http.patch(`documents/${id}/tags`, tags);
    return response;
  } catch (err) {
    throw err;
  }
}
async function addDocumentsBlock(id, blockId, blockOrder) {
  try {
    const response = await http.patch(`documents/${id}/blocks/${blockId}`, {
      value: blockOrder,
    });
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateOrderDocumentsBlocks(id, blocks) {
  try {
    const response = await http.patch(
      `documents/${id}/rpc/change-blocks-order`,
      blocks
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function deleteDocumentBlock(id, blockId) {
  try {
    const response = await http.delete(`documents/${id}/blocks/${blockId}`);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getDocumentsByBlock(blockId) {
  try {
    const result = await http.get(`documents/blocks/${blockId}`);
    return result.data;
  } catch (err) {
    throw err;
  }
}

async function updateDocumentBlockVersion(id, blockId, versionId) {
  try {
    const result = await http.patch(
      `documents/${id}/blocks/${blockId}/rpc/confirm-block-version`,
      { newVersion: versionId }
    );
  } catch (err) {
    throw err;
  }
}

export {
  getDocuments,
  getDocument,
  createDocument,
  updateDocumentsTitle,
  updateDocumentsTags,
  addDocumentsBlock,
  updateOrderDocumentsBlocks,
  deleteDocumentBlock,
  getDocumentsByBlock,
  updateDocumentBlockVersion,
};
